import { useTranslation } from "@/hooks/use-translation"
import { GENERATION_STEP_KEYS, stepStates, type GenerationStepState } from "@/lib/generation-job-detail"
import type { GenerationJobTelemetry } from "@/lib/generation-phase"
import { cn } from "@/lib/utils"

const STEP_BAR: Record<GenerationStepState, string> = {
  done: "bg-ui-accent",
  now: "bg-violet-300",
  warn: "bg-amber-400",
  todo: "bg-ui-surface-raised",
}

/** Шесть делений: очередь → референсы → отправка → у провайдера → скачивание → сохранение. */
export function GenerationStepTrack({
  telemetry,
  labels = false,
  className,
}: {
  telemetry: GenerationJobTelemetry | null | undefined
  /** Подписи под делениями — в панели генерации; в строках списка без них. */
  labels?: boolean
  className?: string
}) {
  const { t } = useTranslation("jobs")
  const states = stepStates(telemetry)
  if (!states) return null

  if (!labels) {
    return (
      <div className={cn("flex gap-[3px]", className)} aria-hidden="true">
        {states.map((state, i) => (
          <span key={GENERATION_STEP_KEYS[i]} className={cn("h-[3px] w-3.5 rounded-full", STEP_BAR[state])} />
        ))}
      </div>
    )
  }

  return (
    <div className={cn("grid grid-cols-6 gap-1", className)}>
      {states.map((state, i) => {
        const key = GENERATION_STEP_KEYS[i]
        return (
          <div key={key} className="flex min-w-0 flex-col gap-1.5">
            <span className={cn("h-[3px] rounded-full", STEP_BAR[state])} />
            <span
              className={cn(
                "truncate text-[10px]",
                state === "warn"
                  ? "text-amber-400"
                  : state === "now"
                    ? "text-ui-text-primary"
                    : "text-ui-text-secondary",
              )}
            >
              {t(`steps.${key}`)}
            </span>
          </div>
        )
      })}
    </div>
  )
}
